$('.js-select').each(function() {
    $(this).select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        placeholder: $(this).data('placeholder')
    });
});

const container = document.querySelector('.popup__form__contact__method');
if (container) {
  const checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'));
  const phoneCheckbox = checkboxes.find(cb => cb.id === 'method-1');

  checkboxes.forEach(cb => {
    cb.addEventListener('change', e => {
      const checked = checkboxes.filter(c => c.checked);

      if (checked.length === 0) {
        e.target.checked = true;
        return;
      }

      if (
        e.target === phoneCheckbox &&
        !e.target.checked && 
        checked.length === 0
      ) {
        e.target.checked = true;
        return;
      }

      if (
        e.target === phoneCheckbox &&
        !e.target.checked &&
        checked.length === 0
      ) {
        e.target.checked = true;
        return;
      }

      const hasOtherChecked = checkboxes.some(
        c => c !== phoneCheckbox && c.checked
      );

      if (!hasOtherChecked) {
        phoneCheckbox.checked = true;
      }
    }); 
  });
}
    
const buttonPromo = document.querySelector('.add__promo');

if (buttonPromo) {
    buttonPromo.addEventListener('click', e => {
        e.preventDefault();
        buttonPromo.classList.toggle('active');
        document.querySelector('.promo__popup').classList.toggle('open')
    });
}

const buttonPeople = document.querySelector('.add__people');
if (buttonPeople) {
    const popupOriginal = document.querySelector('.people__popup');
    const selectTemplate = document.querySelector('.js-select-template');

    const blockTemplate = popupOriginal.cloneNode(true);
    const itemTemplate = blockTemplate.querySelector('.people__popup__block').cloneNode(true);

    popupOriginal.remove();

    let currentPopup = null;

    function removeSelect2Wrappers(root) {
        const wrappers = root.querySelectorAll('.select2, .select2-container, .select2-container--default');
        wrappers.forEach(w => w.remove());
    }

    function createFreshSelectFromTemplate(oldSelect) {
        if (!selectTemplate) return null;
        const fresh = selectTemplate.cloneNode(true);
        fresh.classList.remove('js-select-template');
        fresh.classList.add('js-select');
        fresh.style.display = '';

        if (oldSelect) {
            if (oldSelect.hasAttribute('name')) fresh.setAttribute('name', oldSelect.getAttribute('name'));
            if (oldSelect.hasAttribute('data-placeholder')) fresh.setAttribute('data-placeholder', oldSelect.getAttribute('data-placeholder'));
        }

        return fresh;
    }

    buttonPeople.addEventListener('click', e => {
        e.preventDefault();

        if (!currentPopup) {
            currentPopup = blockTemplate.cloneNode(true);
            removeSelect2Wrappers(currentPopup);

            const oldSelects = Array.from(currentPopup.querySelectorAll('.js-select'));
            oldSelects.forEach(old => {
                const fresh = createFreshSelectFromTemplate(old);
                if (fresh) old.replaceWith(fresh);
            });

            const parentContainer = buttonPeople.closest('.popup__form__buttons_item');
            if (parentContainer) parentContainer.appendChild(currentPopup);

            buttonPeople.classList.add('active');
            currentPopup.classList.add('open');

            initPopupLogic(currentPopup, itemTemplate);

            $(currentPopup).find('.js-select').select2({
                width: '100%',
                minimumResultsForSearch: Infinity, 
                placeholder: function () {
                    return $(this).data('placeholder');
                }
            });

        } else {
            currentPopup.remove();
            currentPopup = null;
            buttonPeople.classList.remove('active');
        }
    });

    function initPopupLogic(popupEl, itemTemplate) {
    const addBtn = popupEl.querySelector('.people__block__add');
    const blockContainer = popupEl;

    if (addBtn) {
        addBtn.addEventListener('click', e => {
        e.preventDefault();
        const newItem = itemTemplate.cloneNode(true);
        removeSelect2Wrappers(newItem);

        const oldSelect = newItem.querySelector('.js-select');
        if (oldSelect) {
            const freshSelect = createFreshSelectFromTemplate(oldSelect);
            if (freshSelect) oldSelect.replaceWith(freshSelect);
        }

        blockContainer.insertBefore(newItem, addBtn);
        attachDeleteHandler(newItem);

        $(newItem).find('.js-select').select2({
            width: '100%',
            minimumResultsForSearch: Infinity, 
            placeholder: function () {
            return $(this).data('placeholder');
            }
        });
        });
    }

    popupEl.querySelectorAll('.people__popup__block').forEach(attachDeleteHandler);
    }

    function attachDeleteHandler(block) {
        const delBtn = block.querySelector('.button-delete');
        if (!delBtn) return;
        delBtn.addEventListener('click', e => {
            e.preventDefault();
            $(block).find('.js-select').select2('destroy');
            block.remove();
        });
    }

}

document.querySelector('body').addEventListener('click', event => {
    if (document.querySelector('.popup')) {
        if (event.target.closest('.js-open-popup')) {
            event.preventDefault();
            document.querySelector('.popup').classList.add('popup__open');
            document.querySelector('body').classList.add('body__popup__open');
        }
        if (event.target.closest('.popup__close')) {
            event.preventDefault();
            document.querySelector('.popup').classList.remove('popup__open');
            document.querySelector('body').classList.remove('body__popup__open');
        }
        if (!event.target.closest('.js-open-popup') 
                && !event.target.closest('.popup__flex') 
                && !event.target.closest('.button-delete')) {
            document.querySelector('.popup').classList.remove('popup__open');
            document.querySelector('body').classList.remove('body__popup__open');
        }
    }
})

